import React, {useEffect, useState} from "react";
import QuadralModal from "@quadral/quadral-component-common/dist/components/modal"
import { onlineProcessesService } from "../../services";
import { QuadralLoaderProvider } from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography'
import QuadralContainer from '@quadral/quadral-component-common/dist/components/container'
import QuadralButton from "@quadral/quadral-component-common/dist/components/button"
import QuadralCheckBox from "@quadral/quadral-component-common/dist/components/checkbox"
import { quadralToast } from "@quadral/quadral-component-common/dist/components/toast"

export default function ParticipationValidationModal ({open, setOpen, statuses, getDocStatusCount, getDocStatusIcon, getDocStatus, participation, setParticipationVerified, updateParticipation, showLoader, hideLoader, ...props}) {

    const [decision, setDecision] = useState('valide');
    const [params, setParams] = useState('');
    const [isComplementAttendu, setIsComplementAttendu] = useState(false);

    function validateParticipation(status){
        showLoader();
        const participationId = participation?.id;
        const body = status;
        onlineProcessesService.updateParticipation({ participationId }, body)
            .then(response => {
                console.log(participation, isComplementAttendu);
                hideLoader();
                if(status === "reponse_validee") setParticipationVerified(true);
                updateParticipation();
                props.quadralToast.success(`${status === "reponse_validee" ? "Participation validée" : status === "annulee" ? "Participation annulée" : "Compléments demandés"} avec succès.`);
                setOpen(false);
            })
            .catch(error => {
                hideLoader();
                props.quadralToast.error(error.response?.data?.message || 'Erreur lors de la vérification de la participation.');
                setOpen(false);
            });
    }

    useEffect(()=>{
        if(decision === "valide"){
            setParams("reponse_validee")
        } else if (decision === "complement"){
            setParams("complements_attendu")
        } else {
            setParams("annulee")
        }
    },[decision])

    useEffect(() => {
        setIsComplementAttendu(participation?.status === 'complements_attendu');
    }, [participation]);
    
    return (
        <QuadralModal
            open={open}
            setOpen={setOpen}
            title='Terminer la vérification'
            noButton
            action={<>
                <QuadralButton 
                    color='secondary' 
                    onClick={() => setOpen(false)}
                >
                        Annuler
                </QuadralButton>
                <QuadralButton 
                    color='primary' 
                    onClick={()=> {if(isComplementAttendu && params === "complements_attendu") { 
                    quadralToast.error('Sélectionnez une autre décision.')
                        } else { 
                            validateParticipation(params); }
                        }
                    }
                >
                        Confirmer
                </QuadralButton>
            </>}
        >
            <QuadralLoaderProvider>
                <QuadralTypography variant='h4'>Résumé du traitement des pièces justificatives</QuadralTypography>
                {statuses && (<>
                    <QuadralContainer orientation='column'>
                        <QuadralTypography color='error'> 
                            {getDocStatusIcon("refuse")} {getDocStatus("refuse")} : {getDocStatusCount("refuse")} 
                        </QuadralTypography>
                        <QuadralTypography color='success'> 
                            {getDocStatusIcon("valide")} {getDocStatus("valide")} : {getDocStatusCount("valide")} 
                        </QuadralTypography>
                        
                    </QuadralContainer>
                </>)}
                <QuadralTypography variant='h4'>Décision sur la participation</QuadralTypography>
                <QuadralContainer sx={{ padding: '0.25rem' }} orientation='column'>
                    <QuadralCheckBox 
                        value='valide' 
                        label="Participation validée"
                        checked={decision === 'valide'}
                        onChange={(e) => setDecision(e.target.value)}
                    />
                    <QuadralCheckBox 
                        value='complement' 
                        label="Demander des compléments" 
                        checked={decision === 'complement'}
                        onChange={(e) => setDecision(e.target.value)}
                        disabled={isComplementAttendu}
                    />
                    <QuadralCheckBox 
                        value='annulee'
                        label="Participation annulée" 
                        checked={decision === 'annulee'}
                        onChange={(e) => setDecision(e.target.value)}
                    />
                </QuadralContainer>
            </QuadralLoaderProvider>
        </QuadralModal>
    );
}